module.exports = __webpack_public_path__ + "a78edae0a60f15623f2ddba5ab161f86.jpg";